import { type RouteObject } from 'react-router'

import {
  ALERTS_DETAIL_PATH,
  ALERTS_DETAIL_TRANSACTION_PATH,
  ALERTS_TRANSACTION_PATH,
  ALERTS_URL,
} from 'features/alerts/paths'
import { lazyDefault } from 'routes/lazy-route'

// A factory, not a hoisted const — react-router mutates a `lazy` object while
// resolving it, so two routes sharing one object silently break the second.
const alertsPage = (): ReturnType<typeof lazyDefault> =>
  lazyDefault(() => import('features/alerts/Container'))

export const alertsRoutes: RouteObject[] = [
  {
    path: ALERTS_URL,
    lazy: alertsPage(),
    handle: {
      featureKey: ALERTS_URL,
      sentryTransactionPath: ALERTS_TRANSACTION_PATH,
    },
  },
  {
    path: ALERTS_DETAIL_PATH,
    lazy: alertsPage(),
    handle: {
      featureKey: ALERTS_URL,
      sentryTransactionPath: ALERTS_DETAIL_TRANSACTION_PATH,
    },
  },
]
